/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Commodity_CodeInputs */

const en_attribute_commodity_code = /** @type {(inputs: Attribute_Commodity_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commodity code`)
};

/**
* | output |
* | --- |
* | "Commodity code" |
*
* @param {Attribute_Commodity_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_commodity_code = /** @type {((inputs?: Attribute_Commodity_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Commodity_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_commodity_code(inputs)
});